var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SESSION_KEYS, getDataFromSession, setDataInSession, } from "./session-storage";
import { getMarketStatus } from "src/apis/dashboard";
let connectedTime;
let disconnectedTime;
let duration;
// let localPublishMessageFunc;
export let dataCheckerInterval;
export let lastSyncTime = Date.now();
// localPublishMessageFunc(SOCKET_EVENT.LOGGLY_DATA, {isSocketConnected : isSocketConnected ? "CONNECT" : "DISCONNECT"})
// export const setPublishMessageFunc=(inputFunc)=>{localPublishMessageFunc=inputFunc}
export const updateSocketConnectTime = (isSocketConnected) => {
    if (isSocketConnected) {
        connectedTime = new Date();
        duration = 0;
    }
    else {
        disconnectedTime = new Date();
        duration = (disconnectedTime === null || disconnectedTime === void 0 ? void 0 : disconnectedTime.valueOf()) - (connectedTime === null || connectedTime === void 0 ? void 0 : connectedTime.valueOf());
    }
    return duration;
};
export const checkAndLogMessage = (method, moreInfo) => {
    let clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    if (!clientCode) {
        clientCode = "";
    }
    //logAdvancedMessage(method, clientCode, moreInfo);
};
export const resetLastSyncTime = (reason) => {
    lastSyncTime = Date.now();
    const getSocketErrorEventTime = getDataFromSession(SESSION_KEYS.WS_ERROR);
    if (getSocketErrorEventTime) {
        const message = {
            duration: Date.now() - getSocketErrorEventTime,
            reason: reason,
            disconnectedError: "",
        };
        checkAndLogMessage("SOCKET_DATA_STREAM_STOPPED", message);
        setDataInSession(SESSION_KEYS.WS_ERROR, undefined);
        // store.dispatch(openSocketNotification(false));
    }
};
export const restartDataChecker = (timeoutValue, isSocketConnected, isWindowFocused) => {
    if (dataCheckerInterval) {
        clearTimeout(dataCheckerInterval);
        dataCheckerInterval = undefined;
    }
    dataCheckerInterval = setTimeout(() => {
        dataCheckForConnectedSocket(isSocketConnected, isWindowFocused);
    }, timeoutValue);
};
export const dataCheckForConnectedSocket = (isSocketConnected, isWindowFocused) => __awaiter(void 0, void 0, void 0, function* () {
    if (Date.now() - lastSyncTime > 3000) {
        if (isSocketConnected && isWindowFocused) {
            let isMarketOpen = true;
            try {
                const response = yield getMarketStatus();
                if (response.data.body.Status == 0) {
                    const marketTypeStatusList = response.data.body.Data;
                    marketTypeStatusList.forEach((singleItem) => {
                        if (singleItem.Exch == "N" && singleItem.ExchType == "C") {
                            isMarketOpen = singleItem.MarketStatus.toLowerCase() != "closed";
                        }
                    });
                }
            }
            catch (error) {
                console.error(error);
            }
            if (isMarketOpen) {
                setDataInSession(SESSION_KEYS.WS_ERROR, lastSyncTime);
                // if (Date.now() - lastSyncTime > 15000) {
                //   store.dispatch(openSocketNotification(true));
                // }
                return;
            }
            else {
                restartDataChecker(10000, isSocketConnected, isWindowFocused);
                resetLastSyncTime("MARKET_CLOSED");
            }
        }
        else {
            //If connecting the socket takes more than 4 secs or if windowfocus is unavailable.
            restartDataChecker(1000, isSocketConnected, isWindowFocused);
            const data = !isWindowFocused
                ? "WINDOW_NOT_FOCUSED"
                : isSocketConnected
                    ? "SOCKET_CONNECTED"
                    : "SOCKET_DISCONNECTED";
            resetLastSyncTime(data);
        }
    }
    else {
        restartDataChecker(1000, isSocketConnected, isWindowFocused);
        resetLastSyncTime("DATA_STARTED_COMING");
        // store.dispatch(openSocketNotification(false));
    }
});
